import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import FileUploadIcon from "@mui/icons-material/FileUploadOutlined";
import { IconButton } from "@mui/material";
import type { GridColDef, GridRowSelectionModel } from "@mui/x-data-grid-premium";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { DataImportFileContainer } from "../../../../../api/types/dataImportTypes";
import { useFileContainersListContext } from "./FileContainersListContext";

const ActionsCell = ({ row }: { row: DataImportFileContainer }) => {
  const { onUpdateFileContainer, onDeleteFileContainer } = useFileContainersListContext();

  return (
    <>
      <IconButton onClick={() => onUpdateFileContainer(row)}>
        <FileUploadIcon />
      </IconButton>
      <IconButton onClick={() => onDeleteFileContainer(row)}>
        <DeleteIcon color="error" />
      </IconButton>
    </>
  );
};

const columns: GridColDef<DataImportFileContainer>[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 2,
    minWidth: 200,
  },
  {
    field: "documentCount",
    headerName: "Documents",
    type: "number",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "createdByUserName",
    headerName: "Created by",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "createdAt",
    headerName: "Created at",
    flex: 1,
    minWidth: 200,
    valueFormatter: (value: string | undefined) => convertISODateTime(value),
  },
  {
    field: "actions",
    headerName: "Actions",
    resizable: false,
    width: 128,
    cellClassName: "grid-row-actions",
    align: "right",
    headerAlign: "right",
    renderCell: ({ row }) => <ActionsCell row={row} />,
  },
];

interface Props {
  rows: DataImportFileContainer[];
  rowSelectionModel: GridRowSelectionModel;
  onRowSelectionModelChange: (selection: GridRowSelectionModel) => void;
  loading?: boolean;
}

const FileContainersGrid = ({ rows, rowSelectionModel, onRowSelectionModelChange, loading }: Props) => {
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      loading={loading}
      noScrollableContainer
      noRowsText="No files found. Please add a new File Container and upload files to it."
      rowSelectionModel={rowSelectionModel}
      onRowSelectionModelChange={onRowSelectionModelChange}
      checkboxSelection
      disableMultipleRowSelection
      disableColumnReorder
      disableColumnSorting
    />
  );
};

export default FileContainersGrid;
